// api/index.ts
const API_URL = process.env.NEXT_PUBLIC_API_URL;

if (API_URL === undefined) {
  throw new Error("NEXT_PUBLIC_API_URL not set");
}

export const GET_LORAS = `${API_URL}/images/loras`;
export const GET_FLUX_LORAS = `${API_URL}/images/flux-loras`;

//////////////////////////////Users Routes//////////////////////////////////
export const POST_SIGN_UP = `${API_URL}/auth/signin`;
export const GET_PROFILE = `${API_URL}/users/profile`;
export const GET_CREATIONS = `${API_URL}/users/image-generations`;
export const DELETE_MODEL = `${API_URL}/users/delete_model`;
export const DELETE_IMAGE = `${API_URL}/users/delete_image`;
export const DELETE_ACCOUNT = `${API_URL}/users/delete_user_account`;
export const GET_MODEL_CREATIONS = (id: string) =>
  `${API_URL}/users/image-generations/${id}`;
export const GET_MODEL_CREATIONS_STAR_SORT = (id: string) =>
  `${API_URL}/users/image-generations-starred-sort/${id}`;
export const GET_USER_MODELS = `${API_URL}/users/private-models`;
export const GET_USER_MODELS_NAMES = `${API_URL}/users/private-models-names`;
export const GET_USER_MODEL = (name: string) =>
  `${API_URL}/users/private-models/${name}`;
export const GET_USER_MODEL_BY_ID = (id: string) =>
  `${API_URL}/users/private-model/${id}`;
export const POST_TRACK_USER_SALE = `${API_URL}/users/track_sale`;
export const POST_UPDATE_CONSENTS = `${API_URL}/users/update-consents`;
export const GET_IMG_GEN_MODE_PRICE = `${API_URL}/images/prices`;
export const WSS_IMG_GEN = (jwt: string, mode: string) =>
  `${API_URL.replace(
    "http",
    "ws"
  )}/images/generate?mode=${mode}&authorization=Bearer ${jwt}`;
export const GET_IMAGE_PROMPT = (file_name: string) =>
  `${API_URL}/prompts/get-prompt/${file_name}`;
export const GET_USER_TRANSACTIONS = `${API_URL}/users/credit-transactions`;
export const POST_EMAIL_OTP = `${API_URL}/auth/email-otp`;
export const GET_API_KEY = `${API_URL}/users/api-key`;
export const POST_GENERATE_API_KEY = `${API_URL}/users/generate-api-key`;
export const DELETE_API_KEY = `${API_URL}/users/delete-api-key`;
export const POST_LORA_FLUX_PLG_TXT2IMG = `${API_URL}/images/generate-image-with-lora`;
export const POST_LORA_FLUX_PLG_IMG2IMG = `${API_URL}/images/generate-image-to-image-with-lora`;
export const POST_LORA_FLUX_PLG_IMG2IMG_MASK = `${API_URL}/images/generate-image-to-image-mask-with-lora`;
export const PATCH_CHECKPOINT_AUTO_EXTEND = `${API_URL}/users/checkpoint/auto-extend`;
export const UPDATE_MODEL_DISPLAY_NAME = `${API_URL}/users/model/update-display-name`
export const UPDATE_MODEL_THUMBNAIL = (model_username: string)  => `${API_URL}/models/${model_username}/update-thumbnail`
export const PATCH_TOGGLE_STAR = (image_id: string) =>
  `${API_URL}/users/image-generations/${image_id}/star`;
export const GET_GALLERY_IMAGES = `${API_URL}/images/gallery-images`;
export const GET_USERNAME_BY_FILENAME = (file_name: string) =>
  `${API_URL}/images/get-username-by-filename?file_name=${encodeURIComponent(file_name)}`;

//////////////////////////////Payments Routes//////////////////////////////////
export const POST_CREATE_PAYMENT = `${API_URL}/payments/create_crypto_payment`;
export const GET_PAYMENT_STATUS = `${API_URL}/payments/payment_status`;
export const POST_CREATE_STRIPE_CHECKOUT_SESSION = (plan_name: string) =>
  `${API_URL}/stripe/create-checkout-session?plan_name=${plan_name}`;
export const GET_STRIPE_SESSION_STATUS = (session_id: string) =>
  `${API_URL}/stripe/session-status/${session_id}`;
export const POST_CREATE_PAYABL_CHECKOUT_SESSION = `${API_URL}/payabl/create-payabl-session`;
export const POST_CREATE_KESSPAY_CHECKOUT_SESSION = (plan_name: string) => `${API_URL}/kesspay/create-checkout-session?plan_name=${plan_name}`;
export const  POST_CREATE_QFPAY_CHECKOUT_SESSION = (plan_name: string) => `${API_URL}/qfpay/create-checkout-session?plan_name=${plan_name}`;


//////////////////////////////Models Routes//////////////////////////////////
export const GET_ALL_MODELS = `${API_URL}/models/public-models`;
export const GET_MODEL = (name: string) =>
  `${API_URL}/models/public-models/${name}`;
export const GET_FORUM_GENERATIONS = (name: string) =>
  `${API_URL}/models/public-models/${name}/image-generations`;
export const POST_CREATE_USER_MODEL = `${API_URL}/models/user-add-model`;
export const POST_TRAIN_USER_MODEL = `${API_URL}/models/create`;
export const POST_TRAIN_USER_MODEL_FLUX = `${API_URL}/models/create-flux`;
export const GET_CUSTOM_PROMPT_MAX_LENGTH = `${API_URL}/images/custom-prompt-max-length`;
export const POST_EXTEND_CKPT = (checkpoint_file_name: string) =>
  `${API_URL}/models/extend-checkpoint/${checkpoint_file_name}`;
export const POST_EXTEND_FLUX = (model_id: string) =>
  `${API_URL}/models/extend-flux?model_id=${model_id}`;
export const GET_REMIX_GALLERY = `${API_URL}/images/remix-gallery`;
export const DELETE_ALL_IMAGE_GENERATIONS = `${API_URL}/users/image-generations`;
export const POST_UPSCALE_IMAGE = `${API_URL}/images/upscale-image`
export const GET_IMAGE_BY_ID = (id: string) =>
  `${API_URL}/images/get-image-by-id?image_id=${id}`;

//////////////////////////////Admin Routes//////////////////////////////////
export const UPLOAD_LORA = `${API_URL}/admin/upload-lora`;
export const UPLOAD_FLUX_LORA = `${API_URL}/admin/upload-flux-lora`;
export const GET_PAYPAL_TRANSACTIONS = `${API_URL}/admin/list-paypal-transactions`;
export const POST_SCRAPE_CIVIT = `${API_URL}/admin/scrape`;
export const ADMIN_DELETE_ACCOUNT = `${API_URL}/admin/admin_delete_user_account/`;
export const POST_ADD_CREDIT = (user_id: string, credit_amount: number) =>
  `${API_URL}/admin/add-credits/${user_id}?credit_amount=${credit_amount}`;
export const DELETE_USER_AND_MODELS = (user_id: string) =>
  `${API_URL}/admin/delete-user-and-models/${user_id}`;
export const POST_CREATE_MODEL = `${API_URL}/admin/add-model`;
export const POST_UPDATE_MODEL = (id: string) =>
  `${API_URL}/admin/update-model/${id}`;
export const POST_UPLOAD_CHECKPOINT = `${API_URL}/admin/upload-checkpoint`;
export const POST_ADD_CHECKPOINT = `${API_URL}/admin/add-checkpoint`;
export const DELETE_CHECKPOINT = (id: string) =>
  `${API_URL}/admin/delete-checkpoint/${id}`;
export const GET_DOWNLOAD_CHECKPOINT = (checkpoint_file_name: string) =>
  `${API_URL}/admin/download-checkpoint/${checkpoint_file_name}`;
export const POST_PAGE_VIEW = `${API_URL}/mixpanel/track_event`;
export const GET_INTERNAL_STYLES = `${API_URL}/admin/styles`;
export const GET_ADMIN_IMAGE_GENERATIONS = (username?: string) =>
  `${API_URL}/admin/image-generations/${username}`;
export const POST_CREATE_STYLE = `${API_URL}/admin/add-style`;
export const POST_UPDATE_STYLE = (id: string) =>
  `${API_URL}/admin/update-style/${id}`;
export const DELETE_STYLE = (id: string) =>
  `${API_URL}/admin/delete-style/${id}`;
export const GET_INTERNAL_MODEL_CATEGORIES = `${API_URL}/admin/model-categories`;
export const GET_INTERNAL_OPTION_CATEGORIES = `${API_URL}/admin/option-categories`;
export const POST_CREATE_OPTION_CATEGORY = `${API_URL}/admin/add-option-category`;
export const POST_UPDATE_FEATURED_STATUS = (
  username: string,
  featured: boolean
) => `${API_URL}/admin/models/${username}/featured?featured=${featured}`;
export const POST_UPDATE_OPTION_CATEGORY = (id: string) =>
  `${API_URL}/admin/update-option-category/${id}`;
export const DELETE_OPTION_CATEGORY = (id: string) =>
  `${API_URL}/admin/delete-option-category/${id}`;
export const POST_CREATE_OPTION = `${API_URL}/admin/add-option`;
export const POST_UPDATE_OPTION = (id: string) =>
  `${API_URL}/admin/update-option/${id}`;
export const DELETE_OPTION = (id: string) =>
  `${API_URL}/admin/delete-option/${id}`;
export const GET_ALL_USERS = `${API_URL}/admin/list-users`;
export const GET_ALL_TRANSACTIONS = `${API_URL}/admin/list-credit-transactions`;
export const UPLOAD_IMAGES_ENDPOINT = (username: string) =>
  `${API_URL}/admin/upload-images/${username}`;
export const POST_ADD_CONTROLNET_IMAGES_TO_OPTION = (id: string) =>
  `${API_URL}/admin/add-controlnet-images/${id}`;
export const DELETE_CONTROLNET_IMAGE = (file_name: string) =>
  `${API_URL}/admin/delete-controlnet-image/${file_name}`;
export const GET_ADMIN_ALL_MODELS = `${API_URL}/admin/models`;
export const GET_ADMIN_ALL_PENDING_MODELS = `${API_URL}/admin/pending-models`;
export const POST_ADD_REMIX_GALLERY_IMAGE = `${API_URL}/admin/add-remix-gallery-image`;
export const DELETE_REMIX_GALLERY_IMAGE = (id: string) =>
  `${API_URL}/admin/delete-remix-gallery-image/${id}`;
export const GET_USER_BY_ID = (id: string) =>
  `${API_URL}/admin/user_by_id/${id}`;
export const GET_LORAS_ADMIN = `${API_URL}/admin/loras`;
export const DELETE_LORA = (id: string) => `${API_URL}/admin/delete-lora/${id}`;

export const GET_INSTANCE_STATES = `${API_URL}/images/instance-states`;
export const GET_QUEUE_INFO = `${API_URL}/images/queue-info`;
export const GET_POD_USAGE_STATS = `${API_URL}/admin/pod-usage-stats`;
// api/index.ts
export const GET_ERROR_LOGS = `${API_URL}/admin/list-errors`;
export const UPDATE_MODEL_VISIBILITY = `${API_URL}/admin/update-model-visibility`;
export const POST_BLOCK_USER = (email: string, block: boolean) =>
  `${API_URL}/admin/block-user/${email}?block=${block}`;
export const DELETE_ADMIN_MODEL = `${API_URL}/admin/delete_model`;
export const GET_USER_IMAGE_GENERATION_STATS = `${API_URL}/admin/last-image-generations`;
export const GET_IMAGE_GENERATION_STATS = `${API_URL}/admin/image-generation-stats`;
export const GET_ALL_TRANSACTIONS_NEW = `${API_URL}/admin/fetch-credit-transactions`;
export const GET_MODEL_IMAGES = (modelName: string) => `${API_URL}/models/images/${modelName}`;
export const TOGGLE_GALLERY_APPROVAL = (imageId: string) =>
  `${API_URL}/admin/toggle-approval/${imageId}`;
export const GET_EXPIRED_MODELS = (startDate: string, endDate: string) =>
  `${API_URL}/admin/expired-models?start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`;
